module.exports = __webpack_public_path__ + "img/panda_logo.b1d541bf.png";